module.exports = __webpack_public_path__ + "static/media/interactionBoard.a6adcf9e.svg";